var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardactiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6387 12C11.6387 11.4477 12.0864 11 12.6387 11H18.6387C19.191 11 19.6387 11.4477 19.6387 12V19C19.6387 19.5523 19.191 20 18.6387 20H12.6387C12.0864 20 11.6387 19.5523 11.6387 19V12Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63867 5C3.63867 4.44772 4.08639 4 4.63867 4H7.63867C8.19096 4 8.63867 4.44772 8.63867 5V19C8.63867 19.5523 8.19096 20 7.63867 20H4.63867C4.08639 20 3.63867 19.5523 3.63867 19V5Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6387 5C11.6387 4.44772 12.0864 4 12.6387 4H18.6387C19.191 4 19.6387 4.44772 19.6387 5V7C19.6387 7.55228 19.191 8 18.6387 8H12.6387C12.0864 8 11.6387 7.55228 11.6387 7V5Z",
    stroke: "#623CE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardactiveIcon);
export default __webpack_public_path__ + "static/media/dashboardactiveIcon.be47eb834b34c2b6bedfcf66881ac898.svg";
export { ForwardRef as ReactComponent };